// Convenience for composing common state reducers
module.exports = {
  env: require('./env/reducer'),
  router: require('./router/reducer'),
  user: require('./user/reducer')
}
